import * as React from "react";
import * as ReactDOM from "react-dom";
import { ITableRowEventArgs } from "./models/tableRowEventArgs";

interface IProperties
{
    /**
     * Inline-Style.
     */
    style?: React.CSSProperties,

    /*
     * Gibt oder setzt alle Elemente die diese Komponente umschließt.
     */
    children?: JSX.Element | JSX.Element[],

    /*
     * Gibt oder setzt den Index dieser Zeile.
     */
    rowIndex?: string,

    /*
     * Gibt oder setzt die gebundene DataSource dieser Zeile.
     */
    dataSource?: any,

    /*
     * Gibt oder setzt einen Wert der angibt ob diese Zeile ein Header ist.
     */
    isHeader?: boolean,

    /*
     * Gibt oder setzt einen Wert der angibt ob diese Zeile selektiert ist.
     */
    isSelected?: boolean,

    /*
     * Gibt oder setzt eine callback Methode die bei einem Linksklick auf diese Zeile ausgeführt wird.
     */
    onClick?: (e: ITableRowEventArgs<any>) => void,

    /*
     * Gibt oder setzt eine callback Methode die bei einem Doppelklick auf diese Zeile ausgeführt wird.
     */
    onDoubleClick?: (e: ITableRowEventArgs<any>) => void,

    /*
     * Gibt oder setzt eine callback Methode die bei einem Rechtsklick auf diese Zeile ausgeführt wird.
     */
    onRightClick?: (e: ITableRowEventArgs<any>) => void
}

export class TableRow extends React.Component<IProperties>
{
    public static defaultProps: Partial<IProperties> = {
        isHeader: false,
        isSelected: false
    };

    /**
     * Wird ausgeführt sobald die linke Maustaste betätigt wird.
     * @param e Das auslösende Ereignis.
     */
    private onClick(e: MouseEvent)
    {
        this.emitEvent(e, "onClick");
    }

    /**
     * Wird bei einem Doppelklick ausgewählt.
     * @param e Das auslösende Ereignis.
     */
    private onDoubleClick(e: MouseEvent)
    {
        this.emitEvent(e, "onDoubleClick");
    }

    /**
     * Wird ausgeführt sobald die rechte Maustaste betätigt wird.
     * @param e Das auslösende Ereignis.
     */
    private onRightClick(e: MouseEvent)
    {
        this.emitEvent(e, "onRightClick");
    }

    /**
     * Führt ein Ereignis aus wenn dieses vom übergeordneten Element angegeben wurde.
     * @param e Das auslösende Ereignis.
     * @param event Der Name des Ereignis welches ausgeführt werden soll.
     */
    private emitEvent(e: MouseEvent, event: string)
    {
        const { rowIndex, dataSource } = this.props;
        var eventArgs: ITableRowEventArgs<any> = {
            event: e,
            index: rowIndex,
            dataSource: dataSource
        };

        if (this.props[event] != null)
            this.props[event](eventArgs);
    }

    /**
     * Rendert die <TableRow /> Komponente.
     */
    render()
    {
        var classNames: string[] = ["n-table_row"];

        if (this.props.isHeader)
            classNames.push("n-table_row--header");

        if (this.props.isSelected)
            classNames.push("n-table_row--selected");

        return (
            <div
                style={this.props.style}
                className={classNames.join(" ")}
                onClick={this.onClick.bind(this)}
                onDoubleClick={this.onDoubleClick.bind(this)}
                onContextMenu={this.onRightClick.bind(this)}>
                {this.props.children}
            </div>
        );
    }
}